(function (a) {
    a.fn.buttonState = function (c, b) {
        return this.each(function () {
            var d = a(this);
            if (c == "loading") {
                if (!d.data("originalLabel")) {
                    d.data("originalLabel", d.html())
                }
                d.prop("disabled", true);
                d.html(b || "Loading...")
            }
            if (c == "reset") {
                d.html(d.data("originalLabel"));
                d.prop("disabled", false)
            }
            return d
        })
    }
})(jQuery);
